import { first, switchMap } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StateService } from '../state/state.service';
import { environment } from '@environments/environment.local';

@Injectable({
  providedIn: 'root'
})
export class HeaderInterceptor implements HttpInterceptor {
  private state = inject(StateService);

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.state.tokenRaw$.pipe(first(),
      switchMap(token => {
        const headers = request.headers
          .set('Cache-Control', 'max-age=1, no-cache, no-store')
          .set('auth_token', token || '');


        request = request.clone({
          headers,
        });
        return next.handle(request);
      }));
  }
}
